var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconComponent,_vm._b({tag:"component",staticClass:"inline-block",class:{ 'path-fill-current': !_vm.maintainColor },on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }